<template>
  <JoszakiModal
    :open="isModalOpen"
    :title="$t('questionPage.reportQuestionModal.title')"
    @close="closeModal"
  >
    <template #body>
      <JoszakiLoading :active="isSaving" />
      <p>
        {{ $t("questionPage.reportQuestionModal.info") }}
      </p>
      <JoszakiTextArea
        v-model="questionReportBody"
        :placeholder="$t('questionPage.reportQuestionModal.placeholder')"
      />
    </template>

    <template #footer>
      <div class="flex flex-1 justify-between">
        <JoszakiButton @click="closeModal">
          {{ $t("common.cancel") }}
        </JoszakiButton>
        <JoszakiButton
          type="error"
          icon-left="exclamation-circle"
          :disabled="questionReportBody.length < 5"
          @click="reportQuestion"
        >
          {{ $t("questionPage.reportQuestionModal.submitButton") }}
        </JoszakiButton>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import {
  MODAL_REPORT_QUESTION,
  useQuestionStore,
} from "~/stores/question/question";

export default {
  name: "ReportQuestionModal",
  setup() {
    return {
      questionStore: useQuestionStore(),
    };
  },
  data: () => {
    return {
      questionReportBody: "",
      isSaving: false,
    };
  },
  computed: {
    isModalOpen() {
      return this.questionStore.isModalOpen(MODAL_REPORT_QUESTION);
    },
    question() {
      return (
        this.questionStore.modalInput(MODAL_REPORT_QUESTION)?.question ?? null
      );
    },
  },
  watch: {
    isModalOpen(newIsOpen) {
      if (newIsOpen) {
        this.questionReportBody = "";
      }
    },
  },
  methods: {
    async reportQuestion() {
      if (!this.question) {
        throw new Error("No question selected for report question modal.");
      }

      try {
        this.isSaving = true;

        await this.questionStore.reportQuestion(
          Number(this.question.id),
          this.questionReportBody
        );

        this.closeModal();
        this.$joszaki.toast({
          message: this.$t("questionPage.reportQuestionModal.success"),
          position: "is-top",
          type: "success",
        });
      } catch (e) {
        console.error(e);
        this.$joszaki.toast({
          message: this.$t("questionPage.reportQuestionModal.error"),
          position: "is-top",
          type: "danger",
        });
      } finally {
        this.isSaving = false;
      }
    },
    closeModal() {
      this.questionStore.closeModal();
    },
  },
};
</script>
